var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.shouldCollapse
    ? _c(
        "div",
        {
          staticClass: "action-menu",
        },
        [
          _c(
            "button",
            {
              staticClass: "action-menu-icon",
              attrs: {
                title: _vm.tooltip,
                "aria-expanded": "false",
              },
            },
            [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "action-menu-content",
            },
            [
              _c(
                "div",
                {
                  staticClass: "action-menu-title",
                },
                [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "action-menu-list",
                },
                _vm._l(_vm.navigationItems, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.id,
                      staticClass: "action-menu-item",
                      class: {
                        "action-menu-item-disabled": item.disabled,
                      },
                    },
                    [
                      item.disabled
                        ? _c(
                            "label",
                            _vm._b(
                              {
                                attrs: {
                                  "aria-disabled": "true",
                                },
                              },
                              "label",
                              item.attributes,
                              false
                            ),
                            [
                              item.icon
                                ? _c("studip-icon", {
                                    staticClass: "action-menu-item-icon",
                                    attrs: {
                                      shape: item.icon,
                                      role: "inactive",
                                    },
                                  })
                                : _c("span", {
                                    staticClass: "action-menu-no-icon",
                                  }),
                              _vm._v(
                                "\n\n                    " +
                                  _vm._s(item.label) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        : item.type === "separator"
                        ? _c("hr")
                        : item.type === "link"
                        ? _c(
                            "a",
                            _vm._g(
                              _vm._b({}, "a", item.attributes, false),
                              _vm.linkEvents(item)
                            ),
                            [
                              item.icon
                                ? _c("studip-icon", {
                                    staticClass: "action-menu-item-icon",
                                    attrs: {
                                      shape: item.icon,
                                    },
                                  })
                                : _c("span", {
                                    staticClass: "action-menu-no-icon",
                                  }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.label) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        : item.icon
                        ? _c(
                            "label",
                            _vm._g(
                              {
                                staticClass: "undecorated",
                                attrs: {
                                  tabindex: "0",
                                },
                              },
                              _vm.linkEvents(item)
                            ),
                            [
                              _c(
                                "studip-icon",
                                _vm._b(
                                  {
                                    staticClass: "action-menu-item-icon",
                                    attrs: {
                                      shape: item.icon,
                                      name: item.name,
                                    },
                                  },
                                  "studip-icon",
                                  item.attributes,
                                  false
                                )
                              ),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.label) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        : [
                            _c("span", {
                              staticClass: "action-menu-no-icon",
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      name: item.name,
                                    },
                                  },
                                  "button",
                                  item.attributes,
                                  false
                                ),
                                _vm.linkEvents(item)
                              ),
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(item.label) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          ),
        ]
      )
    : _c(
        "div",
        [
          _vm._l(_vm.navigationItems, function (item) {
            return [
              item.disabled
                ? _c(
                    "label",
                    _vm._b(
                      {
                        key: item.id,
                        attrs: {
                          "aria-disabled": "true",
                        },
                      },
                      "label",
                      item.attributes,
                      false
                    ),
                    [
                      _c("studip-icon", {
                        staticClass: "action-menu-item-icon",
                        attrs: {
                          shape: item.icon,
                          title: item.label,
                          role: "inactive",
                        },
                      }),
                    ],
                    1
                  )
                : item.type === "separator"
                ? _c(
                    "span",
                    {
                      key: item.id,
                      staticClass: "quiet",
                    },
                    [_vm._v("|")]
                  )
                : _c(
                    "a",
                    _vm._g(
                      _vm._b(
                        {
                          key: item.id,
                        },
                        "a",
                        item.attributes,
                        false
                      ),
                      _vm.linkEvents(item)
                    ),
                    [
                      _c("studip-icon", {
                        staticClass: "action-menu-item-icon",
                        attrs: {
                          shape: item.icon,
                          title: item.label,
                        },
                      }),
                    ],
                    1
                  ),
            ]
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }